import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
/**
 * Memoized wrapper that renders children unchanged.
 * Use inside a context Provider so that when the provider re-renders (e.g. on state update),
 * the subtree does not re-render unless the `children` prop reference changes.
 * Only components that actually consume the context will re-render when context value changes.
 */
export const StableChildren = React.memo(function StableChildren({ children }) {
    return _jsx(_Fragment, { children: children });
});
